import { Layout } from '@/_shared/components/layout/index.js';
import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import type { RoutePaths } from '@tanstack/router-core';
import { IndexRedirect } from './_shared.js';
import { claimDetailsRoute } from './claim-details.js';
import { dashboardRoute } from './dashboard.js';
import { filedClaimsRoute } from './filed-claims.js';
import { newClaimCreateRoute, newClaimFormRoute } from './new-claim.js';
import { paymentDocumentsRoute } from './payment-documents.js';
import { pendingClaimsRoute } from './pending-claims.js';
import { reportClaimRoute } from './report-claim.js';

export const rootRoute = createRootRoute({
    component: () => <Layout />,
});

const indexRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/',
    component: IndexRedirect,
});

export const routeTree = rootRoute.addChildren([
    indexRoute,
    dashboardRoute,
    pendingClaimsRoute,
    filedClaimsRoute,
    paymentDocumentsRoute,
    newClaimCreateRoute,
    newClaimFormRoute,
    claimDetailsRoute,
    reportClaimRoute,
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}

export type RoutePath = RoutePaths<typeof routeTree>;
